import cookies from 'js-cookie';

import { formatCookieDomain } from './domainParser';

const CART_TOTAL_PRODUCTS_COOKIE_NAME = 'MpShoppingCartTotalProducts';

const CART_SYNCED_SESSION_KEY = 'MpCartSynced';
const CART_SYNCED_STATUS = 'CART_IS_SYNCED';

export const isCartSynced = () => sessionStorage.getItem(CART_SYNCED_SESSION_KEY) === CART_SYNCED_STATUS;
export const setIsCartSynced = () => sessionStorage.setItem(CART_SYNCED_SESSION_KEY, CART_SYNCED_STATUS);

export const getCartCookie = () => ({
  numberOfItems: Number(cookies.get(CART_TOTAL_PRODUCTS_COOKIE_NAME)) || 0,
});

type TSetStartCookieProps = {
  numberOfItems: number;
};

export const setCartCookie = ({ numberOfItems }: TSetStartCookieProps) => {
  cookies.set(CART_TOTAL_PRODUCTS_COOKIE_NAME, numberOfItems, {
    path: '/',
    domain: formatCookieDomain(document.location.hostname),
  });
};
